const urlBase = '/api';

export const rootUrl = () => '/jobs';
export const logoutUrl = () => '/api/logout';
export const authUrl = () => '/api/auth?redirectRoute=';
export const authErrorPath = () => '/authentication-error';
export const profilePath = () => '/profile';
export const logoutPath = () => '/logout';
export const page404Path = () => '/page-not-found';
export const singleJobPath = id => `/jobs/${id}`;

export const jobsUrl = `${urlBase}/jobs`;
export const jobUrl = jobId => `${jobsUrl}/${jobId}`;

export const userUrl = `${urlBase}/auth/user`;
export const setLanguageUrl = `${urlBase}/user/language`;

export const myJobsUrl = (offset, limit) => `${urlBase}/jobs/my?offset=${offset}&limit=${limit}`;
export const otherJobsUrl = (offset, limit) => `${urlBase}/jobs/other?offset=${offset}&limit=${limit}`;
export const tagJobUrl = jobId => `${urlBase}/jobs/${jobId}/tag`;

export const setStatusUrl = id => `${jobUrl(id)}/status`;
export const setPriceUrl = id => `${jobUrl(id)}/price`;
export const setReleaseMethodUrl = id => `${jobUrl(id)}/release`;
export const requestReportLevelUrl = id => `${jobUrl(id)}/actions/report-level`;
export const proposeWarrantyUrl = (id, warranty) => `${jobUrl(id)}/actions/${warranty}`;
export const editTechnicalWarrantyProposalUrl = (jobId, actionRequestId) => `${jobUrl(jobId)}/actions/technical-warranty/${actionRequestId}/edit`;
export const deleteTechnicalWarrantyProposalUrl = (jobId, actionRequestId) => `${jobUrl(jobId)}/actions/technical-warranty/${actionRequestId}/delete`;
export const amendApprovedTechnicalWarrantyDecisionUrl = jobId => `${jobUrl(jobId)}/actions/technical-warranty/amend-approved`;
export const deleteApprovedTechnicalWarrantyDecisionUrl = jobId => `${jobUrl(jobId)}/actions/technical-warranty/delete-approved`
export const amendCommercialDecisionUrl = jobId => `${jobUrl(jobId)}/actions/commercial-decision/amend`;
export const deleteCommercialDecisionUrl = jobId => `${jobUrl(jobId)}/actions/commercial-decision/delete`;
export const approveActionUrl = (id, action, proposalId) => `${jobUrl(id)}/actions/${action}/${proposalId}`;
export const warrantyDateUrl = (id, warrantyType) => `${jobUrl(id)}/equipment-warranty-${warrantyType}-date`;
export const requestReportApprovalUrl = id => `${jobUrl(id)}/actions/approve-report`;
export const reclassifyTechnicalDecisionUrl = id => `${jobUrl(id)}/actions/technical-warranty-reclassification`;
export const reopenJobUrl = id => `${jobUrl(id)}/actions/reopen-report`;
export const addTeamMemberUrl = id => `${jobUrl(id)}/team-members`;
export const removeTeamMemberUrl = (id, userId) => `${jobUrl(id)}/team-members/${userId}`;
export const searchTeamMemberUrl = (id, query) => `${jobUrl(id)}/team-members/${query}`;
export const verifyJobUrl = id => `${jobUrl(id)}/verify`;
export const uploadFileUrl = id => `${jobUrl(id)}/files/`;
export const uploadFileLockedJobUrl = id => `${jobUrl(id)}/files-locked-job`;
export const updateFileUrl = id => `${jobUrl(id)}/files/update`
export const rotateImageUrl = id => `${jobUrl(id)}/files/rotate-image`
export const rotateImageLockedJobUrl = id => `${jobUrl(id)}/files/rotate-image-locked-job`
export const downloadFileUrl = (id, fileName) => `${jobUrl(id)}/files/${fileName}`;
export const getMaterialNumbersUrl = query => `${jobsUrl}/map/stc-material-numbers/${query}`;
export const setMaterialNumberUrl = (id, materialNumber) => `${jobUrl(id)}/material-number/${materialNumber}`;
export const setEquipmentSerialNumberUrl = (id, equipmentNumber) => `${jobUrl(id)}/equipment-serial-number/${equipmentNumber}`;

export const sectionFormUrl = (jobId, section) => `${jobUrl(jobId)}/questions/${section}`;

export const logsUrl = jobId => `${jobUrl(jobId)}/actions-log`;
export const commentsUrl = jobId => `${jobUrl(jobId)}/conversation`;
export const numberOfUnreadCommentsUrl = jobId => `${jobUrl(jobId)}/unseen-messages-number`;
export const clearNumberOfUnreadCommentsUrl = jobId => `${jobUrl(jobId)}/read-unseen-messages`;

export const reportTemplatesUrl = jobId => `${jobUrl(jobId)}/report/get-available-template-file-names`;
export const generateReportUrl = (jobId, description, template, format) => `${jobUrl(jobId)}/report/download-report/${description}/${template}/${format}`;

export const getJobsFromSAPUrl = () => `${urlBase}/jobs/sap`;
export const importJobFromSAPUrl = () => `${urlBase}/jobs/import-sap-job`;

export const getSAPCauseCodes = id => `/api/jobs/${id}/questions/cc-codes/`;

export const getJobsWithSameSerialNumberUrl = serialNumber => `${urlBase}/jobs/equipment-serial-number/${serialNumber}`;
export const linkJobUrl = jobId => `${urlBase}/jobs/${jobId}/link-job`;

export const setCameraButtonPositionUrl = `${urlBase}/user/cameraButtonPosition`;

export const chooseReleaseMethodUrl = jobId => `${urlBase}/jobs/${jobId}/releaseMethod`;

export const rateTechnicalDecisionUrl = (jobId, requestId) => `${urlBase}/jobs/${jobId}/actions/rate-technical-warranty/${requestId}`;

export const getInitialWarrantyCodesUrl = () => `${urlBase}/jobs/initial-warranty-codes`;

export const editInitialWarrantyCodeUrl = jobId => `${urlBase}/jobs/${jobId}/edit-initial-warranty-code`;

export const downloadAllPicturesUrl = jobId => `${urlBase}/jobs/${jobId}/download-zip-file`;

export const downloadSectionPicturesUrl = (jobId, section) => `${urlBase}/jobs/${jobId}/download-zip-file/${section}`;

export const editPictureCommentUrl = (jobId, section) => `${urlBase}/jobs/${jobId}/files/description/${section}`;

export const editPictureCommentLockedJobUrl = (jobId, section) => `${urlBase}/jobs/${jobId}/files/description-locked-job/${section}`;

export const deleteImportedJobUrl = jobId => `${jobUrl(jobId)}/delete-imported-from-sap`;

export const blobServiceUrl = (account, sas) => `https://${account}.blob.core.windows.net?${sas}`;

export const sendFaultyPartsEmailsUrl = jobId => `${urlBase}/jobs/${jobId}/actions/send-faulty-parts-emails`;

export const faultyPartsNotifyTeamUrl = jobId => `${urlBase}/jobs/${jobId}/actions/notify-team-parts-to-return`;

export const getJobByNotificationNumberUrl = notificationNumber => `${urlBase}/jobs/notification-number/${notificationNumber}`;



// WEBPACK FOOTER //
// ./src/constants/urls.js